import React from 'react'
import { StatisticsWidget } from '../Widget'
import { ContentLoader } from '../../'

const dataSchema = [
  {
    title: 'MARKET CAP',
    key: 'total_market_volume',
    isPrice: true,
  },
  {
    title: 'NUMBER OF LISTINGS',
    key: 'listings_count',
  },
  {
    title: 'LISTED DIGITAL SECURITIES',
    key: 'total_market_amount',
  },
  //{
  //  title: 'AVERAGE PPDS',
  //  key: 'average_ppds',
  //  isFloat: true,
  //},
]

const MarketplaceWidget = ({
  data,
  loading,
  divided,
  horizontal,
  width,
  color,
  inverted,
  noTitle,
  className,
}) => {
  if (loading) return <ContentLoader />

  return (
    <StatisticsWidget
      data={data}
      dataSchema={dataSchema}
      title="MARKET SUMMARY"
      noTitle={noTitle}
      divided={divided}
      horizontal={horizontal}
      width={width}
      inverted={inverted}
      color={color}
      className={className}
    />
  )
}

export default MarketplaceWidget
